import React, { Component } from 'react'
import StartFooter from './StartFooter'
import LicencjaHeader from './LicencjaHeader'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import FormHelperText from '@material-ui/core/FormHelperText'
import TextField from '@material-ui/core/TextField'
import ErrorDialog from '../ErrorDialog'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import { regulaminURL, politykaPrywatnosciURL } from '../../lib/consts'
import ArrowLeftIcon from '../../icons/ArrowLeftIcon'

class Account extends Component {
  state = {
    email: '',
    password: '',
    repeatedPassword: '',
    errorEmail: false,
    errorPassword: false,
    errorRepeatedPasswordEmpty: false,
    errorRepeatedPasswordMatch: false,
  }

  getErrorContent(error) {
    return (
      <DialogContent>
        <DialogContentText>
          Przykro nam, ale nie udało się utworzyć konta.
        </DialogContentText>
        <br />
        <DialogContentText>{error}</DialogContentText>
      </DialogContent>
    )
  }

  validateEmail() {
    if (!this.state.email) {
      this.setState({ errorEmail: true })
      return false
    }
    return true
  }

  validatePassword() {
    if (!this.state.password || this.state.password.length < 8) {
      this.setState({ errorPassword: true })
      return false
    }
    return true
  }

  validateRepeatedPassword() {
    if (
      !this.state.repeatedPassword ||
      this.state.repeatedPassword.length < 8
    ) {
      this.setState({ errorRepeatedPasswordEmpty: true })
      return false
    }
    if (
      this.state.password &&
      this.state.password.length >= 8 &&
      this.state.password !== this.state.repeatedPassword
    ) {
      this.setState({ errorRepeatedPasswordMatch: true })
      return false
    }
    return true
  }

  checkValidity() {
    let result = true
    this.setState({
      errorEmail: false,
      errorPassword: false,
      errorRepeatedPasswordEmpty: false,
      errorRepeatedPasswordMatch: false,
    })
    if (!this.validateEmail()) result = false
    if (!this.validatePassword()) result = false
    if (!this.validateRepeatedPassword()) result = false
    return result
  }

  changeEmail(value) {
    this.setState({
      email: value,
    })
  }

  changePassword(value) {
    this.setState({
      password: value,
    })
  }

  changeRepeatedPassword(value) {
    this.setState({
      repeatedPassword: value,
    })
  }

  render() {
    const { onCreateAccount, onCancel, error, onCloseError } = this.props
    return (
      <>
        <section>
          <div className="header">
            <div className="imgContainer">
              <ArrowLeftIcon onClick={onCancel} />
            </div>
            <LicencjaHeader />
          </div>
          <main>
            <div className="accountContent">
              <h2>Utwórz nowe konto</h2>
              <div className="loginText">
                <p className="disabled-subtitle-1">
                  <span className="disabled-subtitle-1">
                    Załóż konto i testuj program, bez jakichkolwiek opłat i
                    zobowiązań.
                  </span>
                </p>
                <p className="disabled-subtitle-1">
                  O zakupie licencji pozwalającej na utrwalenie efektów Twojej
                  pracy
                  <br />w formie pliku XML z e-Sprawozdaniem możesz zadecydować
                  później.
                </p>
              </div>
              <form>
                <FormControl component="fieldset" error={this.state.errorEmail}>
                  <TextField
                    type="email"
                    error={this.state.errorEmail}
                    defaultValue={this.state.email}
                    onChange={e => this.changeEmail(e.target.value)}
                    name="email"
                    label="Adres email"
                    aria-describedby="email-error-text"
                  />
                  {this.state.errorEmail && (
                    <FormHelperText id="email-error-text">
                      Niepoprawna wartość pola
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  component="fieldset"
                  error={this.state.errorPassword}
                >
                  <TextField
                    error={this.state.errorPassword}
                    type="password"
                    placeholder="min. 8 znaków"
                    defaultValue={this.state.password}
                    onChange={e => this.changePassword(e.target.value)}
                    name="haslo"
                    label="Hasło"
                    aria-describedby="password-error-text"
                  />
                  {this.state.errorPassword && (
                    <FormHelperText id="password-error-text">
                      Niepoprawna wartość pola
                    </FormHelperText>
                  )}
                </FormControl>
                <FormControl
                  component="fieldset"
                  error={
                    this.state.errorRepeatedPasswordEmpty ||
                    this.state.errorRepeatedPasswordMatch
                  }
                >
                  <TextField
                    type="password"
                    placeholder="min. 8 znaków"
                    error={
                      this.state.errorRepeatedPasswordEmpty ||
                      this.state.errorRepeatedPasswordMatch
                    }
                    defaultValue={this.state.repeatedPassword}
                    onChange={e => this.changeRepeatedPassword(e.target.value)}
                    name="powtorzonehaslo"
                    label="Powtórzone hasło"
                    aria-describedby="repeated-password-error-text"
                  />
                  {this.state.errorRepeatedPasswordEmpty && (
                    <FormHelperText id="repeated-password-error-text">
                      Niepoprawna wartość pola
                    </FormHelperText>
                  )}
                  {this.state.errorRepeatedPasswordMatch && (
                    <FormHelperText id="repeated-password-error-text">
                      Hasło i powtórzone hasło różnią się
                    </FormHelperText>
                  )}
                </FormControl>
              </form>
              <Button
                className="buttonLogin"
                variant="contained"
                color="primary"
                onClick={() => {
                  if (this.checkValidity())
                    onCreateAccount(this.state.email, this.state.password)
                }}
              >
                UTWÓRZ KONTO
              </Button>
            </div>
          </main>
          <p className="disabled-subtitle-2 regulaminZakladanieKontaText">
            Założenie konta oznacza akceptację
            <span className="link disabled-subtitle-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={regulaminURL}
                className="disabled-subtitle-2 regulaminLink"
              >
                &nbsp;regulaminu&nbsp;
              </a>
            </span>
            oraz
            <span className="link disabled-subtitle-2">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={politykaPrywatnosciURL}
                className="disabled-subtitle-2 regulaminLink"
              >
                &nbsp;polityki prywatności.&nbsp;
              </a>
            </span>
          </p>
        </section>
        <footer>
          <StartFooter />
        </footer>
        <ErrorDialog
          error={error}
          title={'Nie udało się utworzyć konta'}
          content={this.getErrorContent(error)}
          onCloseDialog={onCloseError}
        />
      </>
    )
  }
}

export default Account
